import { VFC } from 'react'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { Event } from 'src/models/Event'
import { LoginUser } from 'src/models/User'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { Pagination } from '../../components/Pagination'
import { EventItemCard } from './EventItemCard'

type EventsLayoutProps = {
  user: LoginUser
  events: Event[]
  pageTitle: string
  setPageIndex: (pageIndex: number) => void
  pageIndex: number
  eventTotal: number
}

export const EventsLayout: VFC<EventsLayoutProps> = ({
  user,
  events,
  pageTitle,
  setPageIndex,
  eventTotal,
  pageIndex,
}) => {
  return (
    <MemberPageWrapper user={user} currentPath="イベント一覧">
      <EventPageLayout>
        <EventPageWrapper>
          {eventTotal > 0 && (
            <div>
              <EventTitleLayout>
                <h2>{pageTitle}</h2>
                <p>
                  決裁者であるご参加者様同士での、つながり・交流や、学び・シェアの場としてご活用していただくオンラインイベント一覧になります。
                </p>
              </EventTitleLayout>
              <EventItemList>
                {events.map((event) => (
                  <EventItemCardWraper key={event.id}>
                    <EventItemCard key={event.id} event={event} />
                  </EventItemCardWraper>
                ))}
              </EventItemList>
              <Pagination
                itemSize={eventTotal}
                setIndex={setPageIndex}
                forcePage={pageIndex - 1}
              ></Pagination>
            </div>
          )}
          {eventTotal == 0 && (
            <EventTitleLayout>
              <h2>現在開催予定のイベントはありません</h2>
            </EventTitleLayout>
          )}
        </EventPageWrapper>
      </EventPageLayout>
    </MemberPageWrapper>
  )
}

const EventPageLayout = styled.div`
  display: block;
`
const EventPageWrapper = styled.div`
  display: block;
  margin: 0 auto;
  padding: 0 20px;
  @media screen and (min-width: 540px) {
    max-width: 1576px;
    padding: 20px 50px;
  }
`
const EventTitleLayout = styled.div`
  margin-bottom: 24px;
  @media screen and (min-width: 540px) {
    margin-bottom: 30px;
  }
  h2 {
    font-weight: ${fontWeightBold};
    font-size: 20px;
    line-height: 1.5;
    letter-spacing: 0.05em;
    margin: 24px auto 8px;
  }
  p {
    font-weight: ${fontWeightBold};
    font-size: 12px;
    letter-spacing: 0.05em;
    line-height: 1.5;
    @media screen and (min-width: 540px) {
      font-size: 18px;
    }
  }
`
const EventItemList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  @media screen and (min-width: 540px) {
    margin: 0 -24px;
  }
`
const EventItemCardWraper = styled.div`
  box-sizing: border-box;
  padding: 0 0 24px;
  align-items: center;
  display: flex;
  width: 100%;
  @media screen and (min-width: 540px) {
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 24px 40px;
  }
  @media screen and (min-width: 1280px) {
    flex-basis: 33.3%;
    max-width: 33.3%;
  }
`
